var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4, _defs5, _path5, _defs6, _path6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _path7, _defs16, _path8, _defs17, _path9, _defs18, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGoogle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 163 35",
    style: {
      enableBackground: "new 0 0 163 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#3C8BD9;}\r\n\t.st1{clip-path:url(#SVGID_4_);fill:#FABC04;}\r\n\t.st2{clip-path:url(#SVGID_6_);fill:#34A852;}\r\n\t.st3{clip-path:url(#SVGID_8_);fill:#FABC04;}\r\n\t.st4{clip-path:url(#SVGID_10_);fill:#E1C025;}\r\n\t.st5{clip-path:url(#SVGID_12_);fill:#757575;}\r\n\t.st6{clip-path:url(#SVGID_30_);fill:#757575;}\r\n\t.st7{clip-path:url(#SVGID_32_);fill:#757575;}\r\n\t.st8{clip-path:url(#SVGID_34_);fill:#757575;}\r\n\t.st9{clip-path:url(#SVGID_36_);fill:#757575;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,5.1c0.4-0.9,0.8-1.8,1.6-2.5c2.9-2.8,7.7-2.1,9.7,1.4c1.5,2.7,3.1,5.3,4.6,8c2.6,4.4,5.1,8.9,7.7,13.3 c2.1,3.7-0.2,8.4-4.4,9.1c-2.6,0.4-5-0.8-6.3-3.1c-2.2-3.9-4.5-7.8-6.7-11.7c0-0.1-0.1-0.2-0.2-0.2c-0.2-0.2-0.3-0.5-0.5-0.7 c-1-1.8-2-3.5-3-5.2c-0.6-1.1-1.3-2.2-1.9-3.4c-0.6-1-0.8-2.1-0.8-3.3C13.6,6.2,13.7,5.6,14,5.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,5.1c-0.1,0.5-0.3,1.1-0.3,1.6c0,1.2,0.3,2.4,0.9,3.5c1.6,2.8,3.3,5.6,4.9,8.5c0.1,0.3,0.3,0.5,0.4,0.7 C19,21,18.1,22.5,17.2,24c-1.2,2.2-2.5,4.3-3.8,6.5c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.3c0.6-2.2,0.1-4.2-1.4-5.9 c-0.9-1-2.1-1.6-3.5-1.8c-1.8-0.3-3.4,0.2-4.8,1.3c-0.3,0.2-0.4,0.5-0.7,0.6c-0.1,0-0.1,0-0.1-0.1C3.6,23,4.3,21.8,5,20.6 c2.9-5.1,5.9-10.2,8.8-15.3C13.9,5.2,14,5.2,14,5.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,24.3c0.3-0.3,0.5-0.5,0.8-0.8c3.6-2.9,9-0.8,9.8,3.7c0.2,1.1,0.1,2.1-0.2,3.2c0,0.1,0,0.2-0.1,0.3 c-0.1,0.2-0.3,0.5-0.4,0.7c-1.3,2.2-3.3,3.3-5.8,3.1c-2.9-0.2-5.2-2.4-5.6-5.3c-0.2-1.4,0.1-2.7,0.8-4c0.1-0.3,0.3-0.5,0.5-0.8 C2.9,24.4,2.8,24.3,3,24.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3,24.3c-0.1,0.1-0.1,0.2-0.2,0.2C2.8,24.4,2.9,24.3,3,24.3L3,24.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.3,30.7c-0.1-0.1,0-0.2,0.1-0.3c0,0,0,0,0.1,0.1L13.3,30.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M57.4,7.4c-4.6,0-8.4,3.7-8.4,8.2s3.8,8.2,8.4,8.2c2.5,0,4.3-0.8,5.7-2.3c1.5-1.5,1.9-3.6,1.9-5.2 c0-0.5,0-1-0.1-1.4h-7.6v2.2h5.4c-0.2,1.3-0.6,2.2-1.2,2.8c-0.8,0.8-2,1.7-4.2,1.7c-3.3,0-5.9-2.7-5.9-5.9s2.6-5.9,5.9-5.9 c1.8,0,3.1,0.7,4,1.6l1.6-1.6C61.7,8.4,59.9,7.4,57.4,7.4z M71.1,13.3c-2.9,0-5.3,2.2-5.3,5.3c0,3.1,2.3,5.3,5.3,5.3 s5.3-2.3,5.3-5.3S74,13.3,71.1,13.3 M71.1,21.9c-1.6,0-3-1.3-3-3.2s1.4-3.2,3-3.2c1.6,0,3,1.3,3,3.2 C74.1,20.5,72.7,21.9,71.1,21.9 M82.6,13.3c-2.9,0-5.3,2.2-5.3,5.3c0,3.1,2.3,5.3,5.3,5.3c2.9,0,5.3-2.3,5.3-5.3 S85.5,13.3,82.6,13.3 M82.6,21.9c-1.6,0-3-1.3-3-3.2s1.4-3.2,3-3.2c1.6,0,3,1.3,3,3.2C85.5,20.5,84.2,21.9,82.6,21.9 M93.9,13.3 c-2.6,0-5,2.3-5,5.3c0,3,2.4,5.3,5,5.3c1.3,0,2.2-0.6,2.8-1.2h0.1v0.8c0,2-1.1,3.1-2.8,3.1c-1.4,0-2.3-1-2.6-1.9l-2,0.8 c0.6,1.4,2.1,3.1,4.7,3.1c2.7,0,5-1.6,5-5.5v-9.5h-2.2v0.8h-0.1C96.1,13.9,95.2,13.3,93.9,13.3 M94.1,21.8c-1.6,0-2.9-1.3-2.9-3.2 s1.3-3.2,2.9-3.2c1.6,0,2.8,1.4,2.8,3.2S95.7,21.8,94.1,21.8 M100.6,8.1h2.3v15.6h-2.3V8.1z M109.1,13.3c-2.8,0-5.1,2.1-5.1,5.3 c0,3,2.3,5.3,5.3,5.3c2.5,0,3.9-1.5,4.4-2.3l-1.8-1.2c-0.6,0.9-1.5,1.5-2.6,1.5c-1.2,0-2.1-0.5-2.6-1.6l7.2-3l-0.2-0.6 C113.2,15.5,111.9,13.3,109.1,13.3 M106.4,18.5c-0.1-2.1,1.6-3.1,2.8-3.1c0.9,0,1.7,0.4,2,1.1L106.4,18.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 1.2,
    y: 0.8,
    width: 37.3,
    height: 46.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,7.8c-5.2,0-9.5,4.2-9.5,9.3s4.3,9.2,9.5,9.2c2.8,0,4.8-0.9,6.5-2.6c1.7-1.7,2.2-4,2.2-5.9 c0-0.6,0-1.1-0.1-1.6h-8.5v2.5H64c-0.2,1.4-0.6,2.5-1.4,3.2c-0.9,0.9-2.3,1.9-4.7,1.9c-3.7,0-6.7-3-6.7-6.7s2.9-6.7,6.7-6.7 c2,0,3.5,0.8,4.6,1.8l1.8-1.8C62.7,8.9,60.7,7.8,57.9,7.8z M73.4,14.4c-3.2,0-5.9,2.5-5.9,6c0,3.5,2.6,6,5.9,6s5.9-2.6,5.9-6 S76.6,14.4,73.4,14.4 M73.4,24.1c-1.8,0-3.3-1.5-3.3-3.7s1.6-3.7,3.3-3.7c1.8,0,3.3,1.5,3.3,3.7C76.7,22.6,75.2,24.1,73.4,24.1  M86.3,14.4c-3.3,0-5.9,2.5-5.9,6c0,3.5,2.6,6,5.9,6c3.2,0,5.9-2.6,5.9-6S89.5,14.4,86.3,14.4 M86.3,24.1c-1.8,0-3.3-1.5-3.3-3.7 s1.6-3.7,3.3-3.7s3.3,1.5,3.3,3.7C89.6,22.6,88.1,24.1,86.3,24.1 M99.1,14.4c-3,0-5.7,2.6-5.7,6c0,3.3,2.7,5.9,5.7,5.9 c1.4,0,2.5-0.6,3.1-1.4h0.1v0.9c0,2.3-1.2,3.5-3.2,3.5c-1.6,0-2.6-1.1-3-2.1l-2.3,1c0.6,1.6,2.4,3.5,5.3,3.5 c3.1,0,5.6-1.8,5.6-6.2V14.8h-2.5v1h-0.1C101.6,15,100.5,14.4,99.1,14.4 M99.3,24c-1.8,0-3.3-1.5-3.3-3.6s1.5-3.7,3.3-3.7 s3.2,1.6,3.2,3.7S101.1,24,99.3,24 M106.7,8.5h2.6v17.6h-2.6V8.5z M116.2,14.4c-3.1,0-5.7,2.4-5.7,6c0,3.4,2.6,6,6,6 c2.8,0,4.4-1.7,5-2.6l-2.1-1.4c-0.7,1-1.6,1.6-3,1.6c-1.4,0-2.3-0.6-2.9-1.8l8.1-3.3l-0.3-0.7C120.9,16.9,119.4,14.4,116.2,14.4  M113.1,20.2c-0.1-2.3,1.8-3.5,3.2-3.5c1.1,0,2,0.5,2.2,1.3L113.1,20.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.2,25.9l6-16h2.3l6,16h-2.3l-1.6-4.3h-6.7l-1.6,4.3H126.2z M130.8,19.6h5.3l-2.6-7.2h-0.1L130.8,19.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M142.7,24.5c-1-1.1-1.5-2.5-1.5-4.2c0-1.6,0.5-3,1.5-4.2c1.1-1.1,2.2-1.7,3.7-1.7c0.8,0,1.6,0.2,2.2,0.5 c0.7,0.4,1.2,0.8,1.6,1.4h0.1l-0.1-1.5V9.8h2.1v16h-2v-1.5h-0.1c-0.4,0.5-0.9,1-1.6,1.4c-0.7,0.4-1.4,0.5-2.2,0.5 C145,26.2,143.7,25.7,142.7,24.5 M149.2,23.3c0.7-0.7,1-1.7,1-2.9c0-1.1-0.3-2.1-1-2.8c-0.6-0.7-1.5-1.1-2.5-1.1s-1.8,0.4-2.5,1.1 c-0.7,0.7-1,1.7-1,2.8s0.3,2.1,1,2.8s1.5,1.1,2.5,1.1C147.8,24.3,148.6,24,149.2,23.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 48.4,
    y: -111.1,
    width: 114.6,
    height: 142.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.7,25.2c-0.8,0.6-1.9,1-3.2,1c-1.1,0-2.1-0.3-2.9-0.9c-0.8-0.6-1.4-1.3-1.8-2.3l1.8-0.8 c0.3,0.6,0.6,1.2,1.2,1.6c0.5,0.4,1.1,0.5,1.7,0.5c0.6,0,1.2-0.1,1.6-0.4c0.5-0.3,0.6-0.6,0.6-1c0-0.7-0.5-1.2-1.6-1.6l-1.9-0.5 c-2.1-0.5-3.2-1.6-3.2-3.1c0-1,0.4-1.8,1.2-2.4c0.8-0.6,1.9-0.9,3.1-0.9c1,0,1.8,0.2,2.6,0.7c0.8,0.5,1.3,1.1,1.6,1.9l-1.8,0.8 c-0.2-0.5-0.5-0.8-1-1.1c-0.5-0.3-1-0.4-1.6-0.4c-0.5,0-1,0.1-1.5,0.4c-0.4,0.3-0.6,0.6-0.6,1c0,0.6,0.6,1.1,1.8,1.3l1.6,0.4 c2.2,0.5,3.2,1.6,3.2,3.3C163,23.8,162.5,24.6,161.7,25.2"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.474247f5.svg";
export { ForwardRef as ReactComponent };